// Generated by ReScript, PLEASE EDIT WITH CARE


var elementsPerChunk = 20;

var seeMoreButtonIdentifier = "paginatedgrid-button-more";

export {
  elementsPerChunk ,
  seeMoreButtonIdentifier ,
}
/* No side effect */
